import React, { useEffect } from "react";
import { ModalPadrao, BtnPadrao, LoadingContainerPadrao } from "../../components/Base";
import { BarChart, CartesianGrid, XAxis, YAxis, Legend, Bar, LineChart, Line, ResponsiveContainer, Tooltip } from "recharts";
import * as api from "./api";
import { useFetch } from "../../components/Hooks/Conexao";
import { connect } from "react-redux";
import { logIn, fetch } from "../../actions/index";
function IndicadoresDetalhe({ detalhe, onCancel, filtros, fetch }) {
  const [dados, listarDados, loading] = useFetch();

  useEffect(() => {
    if (detalhe) {
      listarDados(() => api.getDetalhe(fetch, { ...filtros, detalhe }));
    }
  }, [detalhe]);

  return (
    <ModalPadrao
      visible={detalhe}
      width={window.innerWidth > 1600 ? 1600 : "95%"}
      onCancel={onCancel}
      footer={
        <BtnPadrao type="primary" onClick={onCancel} ghost>
          Sair
        </BtnPadrao>
      }
    >
      <LoadingContainerPadrao loading={loading}>
        {/* <pre>{JSON.stringify(dados, null, 2)}</pre> */}
        <div>
          <div style={{ padding: 10, display: "flex" }}>
            <div style={{ width: "100%", height: 370, padding: 1, marginRight: 10, paddingBottom: 60, boxShadow: "0 0 10px #ddd", borderRadius: 20 }}>
              <h1 style={{ margin: 0, color: "#707070", textAlign: "center" }}>Evolução</h1>
              <ResponsiveContainer>
                <BarChart data={(dados || []).corrente}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="nome" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="valor" fill="#ff8000" />
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div style={{ width: "100%", height: 370, padding: 10, paddingBottom: 40, boxShadow: "0 0 10px #ddd", borderRadius: 20 }}>
              <h1 style={{ margin: 0, color: "#707070", textAlign: "center" }}>Comparação</h1>
              <ResponsiveContainer>
                <LineChart data={(dados || []).comparativoDetalhe}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="nome" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Line name={((dados || []).datas || [])[0]} type="linear" dot={false} dataKey="retrasado" stroke="#9999" strokeWidth={3} />
                  <Line name={((dados || []).datas || [])[1]} type="linear" dot={false} dataKey="passado" stroke="#82ca9d" strokeWidth={3} />
                  <Line name={((dados || []).datas || [])[2]} type="linear" dot={false} dataKey="vigente" stroke="#4791db" strokeWidth={3} />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </LoadingContainerPadrao>
    </ModalPadrao>
  );
}

export default connect(null, { logIn, fetch })(IndicadoresDetalhe);
